module.exports = __webpack_public_path__ + "static/net-and-trident-b5906b1982e23539d73b0092fc502174.png";